import { render, staticRenderFns } from "./AboutSectionTwo.vue?vue&type=template&id=5259762c&"
import script from "./AboutSectionTwo.vue?vue&type=script&lang=js&"
export * from "./AboutSectionTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports